import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth.module.js";

Vue.use(Vuex);

// const debug = import.meta.env.NODE_ENV !== "production";
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    auth,
  },
  strict: debug,
});
